import { formateDate, formatTimeAgo } from "../../../../utils/commonfunction";

const ChatMessage = ({ message, createdAt, reverse }) => {
  return (
    <div className={`media ${reverse ? "flex-row-reverse" : ""}`}>
      {/* <div className="main-img-user online">
        <img src="../assets/img/users/1.jpg" alt="avatar" />
      </div> */}
      <div className="media-body">
        <div className="main-msg-wrapper">{message}</div>
        <div>
          <span>{formateDate(createdAt)}</span>
        </div>
      </div>
    </div>
  );
};

export default ChatMessage;
